import type { IconName } from '@zen/Styleguide';

export enum PurchaseOrderTableVersion {
  CLASSIC = 'CLASSIC',
  NEW = 'NEW'
}

export interface PurchaseOrderTableBannerConfig {
  actionLabel: string;
  icon: IconName;
  message: string;
  targetUrl: string;
  targetVersion: PurchaseOrderTableVersion;
}
